"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseStatusTitleEnum = void 0;
var ExpenseStatusTitleEnum;
(function (ExpenseStatusTitleEnum) {
    ExpenseStatusTitleEnum["WAITING_APPROVAL"] = "Waiting Approval";
    ExpenseStatusTitleEnum["DOCUMENTS_NEEDED"] = "Documents Needed";
    ExpenseStatusTitleEnum["APPROVED"] = "Approved";
    ExpenseStatusTitleEnum["DECLINED"] = "Declined";
})(ExpenseStatusTitleEnum = exports.ExpenseStatusTitleEnum || (exports.ExpenseStatusTitleEnum = {}));
